(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  var STORAGE_KEY = 'aceites:collection:sidebarHidden';

  /* ----- Toggle desktop sidebar (Ocultar / Mostrar filtros) ----- */
  function initSidebarToggle() {
    var section = $('[data-collection]');
    if (!section) return;

    function applyState(hidden) {
      section.dataset.sidebarVisible = hidden ? 'false' : 'true';
      $$('[data-toggle-sidebar]', section).forEach(function (btn) {
        btn.setAttribute('aria-pressed', hidden ? 'false' : 'true');
      });
    }

    var stored = false;
    try { stored = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
    applyState(stored);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-toggle-sidebar]');
      if (!btn || !section.contains(btn)) return;
      var hidden = section.dataset.sidebarVisible !== 'false' ? true : false;
      applyState(hidden);
      try { localStorage.setItem(STORAGE_KEY, hidden ? '1' : '0'); } catch (e) {}
    });
  }

  /* ----- Drawer mobile (Filtrar y ordenar) ----- */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;

    function open() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-drawer]')) { open(); return; }
      if (e.target.closest('[data-close-drawer]')) { close(); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  /* ----- Auto submit de filtros (delegado en document para sobrevivir reemplazos por AJAX) ----- */
  function buildUrlFromForm(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    for (var pair of data.entries()) {
      if (pair[1] === '' || pair[1] == null) continue;
      params.append(pair[0], pair[1]);
    }
    return window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  }

  var filterDebounceTimers = new WeakMap();
  function initFilterForms() {
    document.addEventListener('change', function (e) {
      var form = e.target.closest && e.target.closest('[data-collection-filter-form]');
      if (!form) return;
      var t = e.target;
      if (!t || (t.type !== 'checkbox' && t.type !== 'radio' && t.type !== 'number')) return;
      clearTimeout(filterDebounceTimers.get(form));
      var timer = setTimeout(function () { renderFromUrl(buildUrlFromForm(form)); }, t.type === 'number' ? 500 : 0);
      filterDebounceTimers.set(form, timer);
    });

    document.addEventListener('submit', function (e) {
      if (!e.target.matches || !e.target.matches('[data-collection-filter-form]')) return;
      e.preventDefault();
      renderFromUrl(buildUrlFromForm(e.target));
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-clear-filters]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-clear-filters') || window.location.pathname;
      renderFromUrl(url);
    });
  }

  /* ----- Slider de precio (doble manija) ----- */
  function getPriceSliderParts(slider) {
    return {
      minHandle: slider.querySelector('[data-price-handle="min"]'),
      maxHandle: slider.querySelector('[data-price-handle="max"]'),
      minHidden: slider.querySelector('[data-price-input="min"]'),
      maxHidden: slider.querySelector('[data-price-input="max"]'),
      minDisplay: slider.parentElement && slider.parentElement.querySelector('[data-price-display="min"]'),
      maxDisplay: slider.parentElement && slider.parentElement.querySelector('[data-price-display="max"]'),
      fill: slider.querySelector('[data-price-fill]'),
      rangeMin: parseFloat(slider.dataset.rangeMin) || 0,
      rangeMax: parseFloat(slider.dataset.rangeMax) || 0
    };
  }

  function clampPriceHandles(slider, changedHandle) {
    var p = getPriceSliderParts(slider);
    if (!p.minHandle || !p.maxHandle) return;
    var minVal = parseFloat(p.minHandle.value);
    var maxVal = parseFloat(p.maxHandle.value);
    if (minVal > maxVal) {
      if (changedHandle === p.minHandle) p.minHandle.value = maxVal;
      else p.maxHandle.value = minVal;
    }
  }

  function updatePriceSliderUI(slider) {
    var p = getPriceSliderParts(slider);
    if (!p.minHandle || !p.maxHandle) return;
    var diff = p.rangeMax - p.rangeMin;
    if (diff <= 0) return;
    var minVal = parseFloat(p.minHandle.value);
    var maxVal = parseFloat(p.maxHandle.value);
    var minPct = ((minVal - p.rangeMin) / diff) * 100;
    var maxPct = ((maxVal - p.rangeMin) / diff) * 100;
    if (p.fill) {
      p.fill.style.left = minPct + '%';
      p.fill.style.right = (100 - maxPct) + '%';
    }
    if (p.minDisplay) p.minDisplay.textContent = Math.round(minVal);
    if (p.maxDisplay) p.maxDisplay.textContent = Math.round(maxVal);
  }

  function syncPriceSliderHidden(slider) {
    var p = getPriceSliderParts(slider);
    if (!p.minHandle || !p.maxHandle) return;
    var minVal = parseFloat(p.minHandle.value);
    var maxVal = parseFloat(p.maxHandle.value);
    if (p.minHidden) p.minHidden.value = (minVal > p.rangeMin) ? minVal : '';
    if (p.maxHidden) p.maxHidden.value = (maxVal < p.rangeMax) ? maxVal : '';
  }

  function initPriceSliders() {
    $$('[data-price-slider]').forEach(updatePriceSliderUI);
  }

  function initPriceSliderEvents() {
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || t.type !== 'range') return;
      var slider = t.closest && t.closest('[data-price-slider]');
      if (!slider) return;
      clampPriceHandles(slider, t);
      updatePriceSliderUI(slider);
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'range') return;
      var slider = t.closest && t.closest('[data-price-slider]');
      if (!slider) return;
      clampPriceHandles(slider, t);
      updatePriceSliderUI(slider);
      syncPriceSliderHidden(slider);
      var form = slider.closest('[data-collection-filter-form]');
      if (form) renderFromUrl(buildUrlFromForm(form));
    });
  }

  /* ----- Render AJAX (Section Rendering API) ----- */
  function renderFromUrl(url) {
    var section = $('[data-collection]');
    if (!section) {
      window.location.href = url;
      return;
    }

    section.classList.add('is-loading');

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) {
          window.location.href = url;
          return;
        }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection = doc.querySelector('[data-collection]');
        if (!newSection) {
          window.location.href = url;
          return;
        }

        // Reemplazar grid + paginación
        var newGrid = newSection.querySelector('[data-product-grid]');
        var oldGrid = section.querySelector('[data-product-grid]');
        if (newGrid && oldGrid) {
          oldGrid.replaceWith(newGrid);
        }

        var newPag = newSection.querySelector('.aceites-collection__pagination');
        var oldPag = section.querySelector('.aceites-collection__pagination');
        if (oldPag) oldPag.remove();
        if (newPag) {
          var main = section.querySelector('.aceites-collection__main');
          if (main) main.appendChild(newPag);
        }

        // Reemplazar filtros (counts pueden cambiar) — preservar estado open/closed de los acordeones
        ['desktop', 'mobile'].forEach(function (scope) {
          var newForm = newSection.querySelector('#CollectionFilterForm-' + scope);
          var oldForm = section.querySelector('#CollectionFilterForm-' + scope);
          if (newForm && oldForm) {
            // Preservar qué <details> están open
            var openSet = {};
            $$('[data-filter-group]', oldForm).forEach(function (g, i) { openSet[i] = g.open; });
            oldForm.replaceWith(newForm);
            $$('[data-filter-group]', newForm).forEach(function (g, i) {
              if (openSet[i] != null) g.open = openSet[i];
            });
          }
        });

        // Actualizar URL
        history.replaceState({}, '', url);

        // Refrescar sección dataset por si cambia has-sidebar
        section = $('[data-collection]');
        section.classList.remove('is-loading');

        // Recalcular fill/displays de los sliders (los inputs ya vienen con value correcto)
        initPriceSliders();
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSidebarToggle();
    initDrawer();
    initFilterForms();
    initPriceSliderEvents();
    initPriceSliders();
  });
})();
